import { SecurityGuard } from "@duosoftbg/nacid-components";
import ServiceConfigWrapperPage from "../views/pages/ServiceConfigWrapperPage";
import { seOfficialNoteServiceConfig } from "../config/servicesConfig";
import React from "react";
import ServiceInfoPage from "../views/pages/ServiceInfoPage";
import SEOfficialNoteNewPage from "../views/pages/secondaryEducation/SEOfficialNoteNewPage";

export const seOfficialNoteRoutes = [
  {
    path: "/se-official-note",
    element: (
      <SecurityGuard doCheck={false}>
        <ServiceConfigWrapperPage serviceConfig={seOfficialNoteServiceConfig} wrappedPage={<ServiceInfoPage />} />
      </SecurityGuard>
    ),
  },
  {
    path: "/se-official-note/new",
    element: (
      <SecurityGuard loginOnUnauthorized={true}>
        <ServiceConfigWrapperPage serviceConfig={seOfficialNoteServiceConfig} wrappedPage={<SEOfficialNoteNewPage />} />
      </SecurityGuard>
    ),
  },
];
